import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import * as uuid from 'uuid';

export interface Alert {
  id: string;
  title: string;
  message: string;
}
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  alert$ = new Subject<Alert>();
  constructor() { }

  /**
   * Displays an alert by pushing an alert object to the alert stream.
   *
   * @param title Title of the alert
   * @param message Message of the alert
   */
  showAlert( title: string, message: string) {
    console.log("Showing Alert");
    this.alert$.next({id: uuid.v4(), title, message});
  }

}
